import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Safely coerce an axios error into a display string.
 *
 * FastAPI Pydantic validation errors (HTTP 422) come back as
 *   { detail: [{ type, loc, msg, input, ctx, url }, ...] }
 * — passing that array directly to `toast.error()` (or into any
 * JSX child) makes React throw
 * "Objects are not valid as a React child" and blows up the page.
 *
 * This helper handles the three shapes we see in practice:
 *   • `detail` is a string             → return it verbatim
 *   • `detail` is an array of objects  → join the `msg` fields
 *   • anything else                    → fall back to the caller default
 *
 * Always returns a plain string.
 */
export function formatApiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => (d && typeof d === "object" ? d.msg : d))
      .filter((s) => typeof s === "string" && s.trim());
    if (parts.length) return parts.join("; ");
  }
  if (detail && typeof detail === "object" && typeof detail.msg === "string") {
    return detail.msg;
  }
  return fallback;
}
